/*
 * Tabs
 * @module components
 * @flow
 */

import styled, { css } from 'styled-components/macro';
import { ifProp } from 'styled-tools';

import { Block } from '~/components/Block';
import { Tab } from './components';

export type TabsProps = $Shape<DeviceQuery> & {};

/**
 * Tabs React-component
 * @memberof components
 * @extends Block
 * @example <caption>Simple usage</caption>
 * <Tabs><Tabs.Item icon={<IconWallet />}>My Wealth</Tabs.Item></Tabs>
 * @returns {React.Node<*>} React-component
 */
export const Tabs = styled(Block).attrs(() => ({
  role: 'tablist',
}))`
  position: relative;
  z-index: 2;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;

  ${ifProp(
    { device: 'desktop' },
    css`
      padding: 0 18px;
      justify-content: center;

      .react-tab {
        padding: 9px 15px;

        & + .react-tab {
          margin-left: 10px;
        }
      }
    `,
    css`
      padding: 0 14px;

      .react-tab {
        padding: 7px 0;

        & + .react-tab {
          margin-left: 20px;
        }
      }
    `,
  )}
`;

Tabs.defaultProps = {
  palette: 'grayscale',
  rounded: false,
  elevation: 1,
  testid: 'tabs',
};

Tabs.Item = Tab;
